import React from 'react'

import {
  InputWithTitleStyled,
  EditableSectionTitle,
} from 'Components/Elements/InputWithTitle/InputWithTitle.styled'
import { CSS } from '@stitches/react'
import { Input } from '@clickcease/cc-client-components-lib'

type EditableSectionProps = {
  title: string
  name?: string
  disabled?: boolean
  size?: 'fullRow' | 'small'
  css?: CSS
  value: string | number
  inputType?: string
  placeholder?: string
  onFocusOut?: (value: string | number) => void
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const InputWithTitle = ({
  title,
  name,
  value,
  disabled,
  size,
  css,
  inputType,
  onFocusOut,
  onChange,
  placeholder,
}: EditableSectionProps) => {
  return (
    <InputWithTitleStyled size={size}>
      <EditableSectionTitle>{title}</EditableSectionTitle>
      <Input
        onBlur={() => {
          if (onFocusOut) {
            onFocusOut(value)
          }
        }}
        onChange={(e) => {
          if (onChange) {
            onChange(e)
          }
        }}
        disabled={disabled}
        placeholder={placeholder}
        name={name}
        css={css}
        type={inputType || 'text'}
        value={value}
      />
    </InputWithTitleStyled>
  )
}
